import { useSelector } from 'react-redux';
import { IStore } from 'store/interface';
import { getStoreIdentifiers } from '../../selector';

export const useStoreIdentifiers = () => ({
  identifiers: useSelector<IStore, string[]>(getStoreIdentifiers),
});
